// @ts-nocheck
import { FC } from 'react'
import { ColumnInstance } from 'react-table'
import { RoomList } from '../../../../../coreGlobal/models/default'

type Props = {
    column: ColumnInstance<RoomList>
}

const CustomHeaderColumn: FC<Props> = ({ column }) => (
    <>
        {column.Header && typeof column.Header === 'string' ? (
            <th {...column.getHeaderProps()}>{column.render('Header')}</th>
        ) : (
            column.render('Header')
        )}
    </>
)

export { CustomHeaderColumn }
